/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

// Absolute import
import React from 'react';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SlideDown } from 'react-slidedown';
import s4 from 'react-slidedown/lib/slidedown.css';
// import bootstrap from 'bootstrap/dist/css/bootstrap.css';

// Relative import
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '../../assets/styles/style.sass';
import s2 from './Order.sass';
import Order01SelectVehicle from './Order01SelectVehicle/Order01SelectVehicle';
import Order09Path from './order09Path/Order09Path';
import Order10PickupTime from './Order10PickupTime/Order10PickupTime';
import Order12AddService from './Order12AddService/Order12AddService';
import Order13Remarks from './Order13Remarks/Order13Remarks';
import Order14ContactInfoWithTW from './Order14ContactInfo/Order14ContactInfoWithTW';
import Order17InvoiceInfo from './Order17InvoiceInfo/Order17InvoiceInfo';
import Order18AddPhoto from './Order18AddPhoto/Order18AddPhoto';
import Order05Types from './Order05Type/Order05Types';
import Order19Total from './Order19Total/Order19Total';
import Order20Coupon from './Order20Coupon/Order20Coupon';
import Order21Confirm from './Order21Confirm/Order21Confirm';
import OrderSummary from '../OrderSummary/twOrderSummary';
import { setisNotExpiredLogin } from '../../actions/user';
import ExtraMessageDialog from '../../components/Dialog/extraMessageDialog';
import {
  initOrderDetailInfoAction,
  addUploadedOrderImage,
} from '../../actions/order';

class twOrder extends React.Component {
  static propTypes = {
    currentLocale: PropTypes.string.isRequired,
    orderPriceBreakdownDetail: PropTypes.shape({
      extra_message: PropTypes.string,
    }).isRequired,
    modelData: PropTypes.shape().isRequired,
    modelDataText: PropTypes.shape().isRequired,
    onClickConfirm: PropTypes.func.isRequired,
    isShowOrderDetail: PropTypes.bool.isRequired,
    setting: PropTypes.shape({}).isRequired,
    lang: PropTypes.string.isRequired,
  };

  render() {
    return (
      <div className={`${s2.orderPage}`}>
        <div className={`${s2.fixedContainer}`}>
          <SlideDown closed={!this.props.isShowOrderDetail}>
            {this.props.isShowOrderDetail ? (
              <div className={s2.formBox}>
                <OrderSummary
                  modelDataText={this.props.modelDataText.order}
                  onClickConfirm={this.props.onClickConfirm}
                  modelData={this.props.modelData}
                />
              </div>
            ) : (
              ''
            )}
          </SlideDown>
          <SlideDown closed={this.props.isShowOrderDetail}>
            <div className={s2.formBox}>
              <h2 className={s2.headline}>
                {this.props.modelDataText.order.order_headline}
              </h2>
              <hr className={s2.hrTitle} />
              <Order01SelectVehicle
                currentLocale={this.props.currentLocale}
                modelData={this.props.modelData.order_model_data}
                modelDataText={this.props.modelDataText}
              />
              <Order05Types
                modelData={this.props.modelData.order_model_data}
                modelDataText={this.props.modelDataText.order}
              />
              <Order18AddPhoto
                modelData={this.props.modelData.order_model_data}
                modelDataText={this.props.modelDataText}
              />
              <Order09Path
                modelDataText={this.props.modelDataText.order}
                lang={this.props.lang}
              />
              <Order10PickupTime
                modelData={this.props.modelData.order_model_data}
                modelDataText={this.props.modelDataText.order}
              />
              <Order12AddService
                modelData={this.props.modelData.order_model_data}
                modelDataText={this.props.modelDataText.order}
                lang={this.props.lang}
              />
              <Order14ContactInfoWithTW
                modelData={this.props.modelData.order_model_data}
                modelDataText={this.props.modelDataText.order}
                setting={this.props.setting}
              />
              <Order17InvoiceInfo
                modelData={this.props.modelData.order_model_data}
                modelDataText={this.props.modelDataText.order}
                setting={this.props.setting}
              />
              <Order13Remarks
                modelData={this.props.modelData.order_model_data}
                modelDataText={this.props.modelDataText.order}
                fieldParentName="order_request_extra_attributes"
                fieldChildName="remark_for_admin"
              />
              <hr className={s2.hrTotalPrice} />
              <div className={s2.orderPricingRow}>
                <Order19Total modelDataText={this.props.modelDataText.order} />
                <Order20Coupon modelDataText={this.props.modelDataText.order} />
              </div>
              <Order21Confirm
                modelDataText={this.props.modelDataText.order}
                onClickConfirm={this.props.onClickConfirm}
              />
            </div>
          </SlideDown>
        </div>
        <ExtraMessageDialog
          message={this.props.orderPriceBreakdownDetail.extra_message}
        />
      </div>
    );
  }
}
const mapState = state => ({
  currentLocale: state.intl.locale,
  address: state.order.address,
  isValidOrder: state.order.isValidOrder,
  orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
  images: state.order.images,
});
const mapDispatch = {
  setisNotExpiredLogin,
  initOrderDetailInfoAction,
  addUploadedOrderImage,
};
export default connect(mapState, mapDispatch)(
  withStyles(bootstrap, s, s2, s4)(twOrder),
);



// WEBPACK FOOTER //
// ./src/routes/order/twOrder.js